import React from 'react'
import PropTypes from 'prop-types'

const DownloadStatusReadyIcon = props => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.375 15.8244V5.66666C13.375 5.32148 13.6548 5.04166 14 5.04166C14.3452 5.04166 14.625 5.32148 14.625 5.66666V15.8244L16.8914 13.558C17.1355 13.314 17.5312 13.314 17.7753 13.558C18.0194 13.8021 18.0194 14.1979 17.7753 14.4419L14.4419 17.7753C14.1979 18.0193 13.8021 18.0193 13.5581 17.7753L10.2247 14.4419C9.98065 14.1979 9.98065 13.8021 10.2247 13.558C10.4688 13.314 10.8645 13.314 11.1086 13.558L13.375 15.8244ZM5.875 18.1667C5.875 17.8215 6.15482 17.5417 6.5 17.5417C6.84518 17.5417 7.125 17.8215 7.125 18.1667V20.6667C7.125 21.242 7.59137 21.7083 8.16667 21.7083H19.8333C20.4086 21.7083 20.875 21.242 20.875 20.6667V18.1667C20.875 17.8215 21.1548 17.5417 21.5 17.5417C21.8452 17.5417 22.125 17.8215 22.125 18.1667V20.6667C22.125 21.9323 21.099 22.9583 19.8333 22.9583H8.16667C6.90101 22.9583 5.875 21.9323 5.875 20.6667V18.1667Z"
      fill="#4A4A4A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5 29C25.0899 29 28 26.0899 28 22.5C28 18.9101 25.0899 16 21.5 16C17.9101 16 15 18.9101 15 22.5C15 26.0899 17.9101 29 21.5 29Z"
      fill="white"
    />
    <path
      opacity="0.1"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5 29C25.0899 29 28 26.0899 28 22.5C28 18.9101 25.0899 16 21.5 16C17.9101 16 15 18.9101 15 22.5C15 26.0899 17.9101 29 21.5 29Z"
      fill="#8CE563"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.6132 22.0066C25.6132 21.8168 25.7671 21.6629 25.957 21.6629C26.1468 21.6629 26.3007 21.8168 26.3007 22.0066V22.4331C26.2995 24.6151 24.8631 26.5364 22.7706 27.1551C20.6781 27.7738 18.4279 26.9425 17.2403 25.1119C16.0526 23.2814 16.2105 20.8877 17.6282 19.229C19.0459 17.5703 21.3858 17.0416 23.379 17.9297C23.5524 18.007 23.6303 18.2102 23.5531 18.3836C23.4758 18.557 23.2726 18.635 23.0992 18.5577C21.3841 17.7935 19.3707 18.2484 18.1508 19.6757C16.9309 21.103 16.7951 23.1626 17.817 24.7378C18.839 26.3129 20.7752 27.0282 22.5757 26.4958C24.3762 25.9635 25.6122 24.3102 25.6132 22.4329V22.0066ZM21.3736 22.8631L26.1722 18.0645C26.3065 17.9302 26.5241 17.9302 26.6584 18.0645C26.7926 18.1987 26.7926 18.4164 26.6584 18.5506L21.6167 23.5923C21.4825 23.7265 21.2648 23.7265 21.1306 23.5923L19.7556 22.2173C19.6213 22.083 19.6213 21.8654 19.7556 21.7311C19.8898 21.5969 20.1075 21.5969 20.2417 21.7311L21.3736 22.8631Z"
      fill="#8CE563"
    />
  </svg>
)

DownloadStatusReadyIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

DownloadStatusReadyIcon.defaultProps = {
  width: 32,
  height: 32,
}

export default DownloadStatusReadyIcon
